import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import { lazy, Suspense, memo } from "react";
import { VerbatimsProvider } from "../contexts/VerbatimsProvider";
import FilterBreadcrumbs from "./FilterBreadcrumbs";

// Lazy load heavy chart components for better initial load performance
const DataDistributionCard = lazy(() => import("./cards/DataDistributionCard"));
const EcosystemMapCard = lazy(() => import("./cards/EcosystemMapCard"));
const EmergingTopicsCard = lazy(() => import("./cards/EmergingTopicsCard"));
const KeywordsCloudCard = lazy(() => import("./cards/KeywordsCloudCard"));
const RelevantTextRecordsCard = lazy(() => import("./cards/RelevantTextRecordsCard/RelevantTextRecordsCard"));
const SentimentOverTimeCard = lazy(() => import("./cards/SentimentOverTimeCard"));
const TopicDistributionCard = lazy(() => import("./cards/TopicDistributionCard"));

// Skeleton loader for cards
const CardSkeleton = ({ height = 300 }: { height?: number }) => (
  <Box sx={{ width: "100%", height }}>
    <Skeleton variant="rounded" height="100%" animation="wave" />
  </Box>
);

const ChartGrid = (): JSX.Element => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <FilterBreadcrumbs />
    </Grid>
    <Grid item xs={12}>
      <Suspense fallback={<CardSkeleton height={100} />}>
        <DataDistributionCard />
      </Suspense>
    </Grid>

    <Grid
      item
      xs={12}
      sx={{ display: "flex", gap: "16px", height: "100%", position: "relative", minHeight: 0, aspectRatio: "2.75" }}
    >
      <Suspense fallback={<CardSkeleton />}>
        <EmergingTopicsCard sx={{ flex: 7 }} />
      </Suspense>
      <Suspense fallback={<CardSkeleton />}>
        <KeywordsCloudCard sx={{ flex: 5 }} />
      </Suspense>
    </Grid>

    <Grid
      item
      xs={12}
      sx={{ display: "flex", gap: "16px", height: "100%", position: "relative", minHeight: 0, aspectRatio: "2.75" }}
    >
      <Suspense fallback={<CardSkeleton />}>
        <SentimentOverTimeCard sx={{ flex: 7 }} />
      </Suspense>
      <Suspense fallback={<CardSkeleton />}>
        <EcosystemMapCard sx={{ flex: 5 }} />
      </Suspense>
    </Grid>

    <Grid
      item
      xs={12}
      sx={{ display: "flex", gap: "16px", height: "100%", position: "relative", minHeight: 0, aspectRatio: "2.75" }}
    >
      <Suspense fallback={<CardSkeleton />}>
        <TopicDistributionCard sx={{ flex: 12 }} />
      </Suspense>
    </Grid>

    <Grid item xs={12}>
      <VerbatimsProvider>
        <Suspense fallback={<CardSkeleton height={400} />}>
          <RelevantTextRecordsCard />
        </Suspense>
      </VerbatimsProvider>
    </Grid>
  </Grid>
);

export default memo(ChartGrid);
